<section [ngClass]="openedFromMatAccountpreview ? '' : 'main-section'">
  <header *ngIf="!openedFromMatAccountpreview" class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center px-0">
      <a
        class="btn btn-link me-3 p-0 d-block d-xl-none"
        data-bs-toggle="offcanvas"
        href="#offcanvasExample"
        role="button"
        aria-controls="offcanvasExample">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 7H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"/>
          <path
            d="M3 12H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"/>
          <path
            d="M3 17H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"/></svg></a>

      <h3 *ngIf="!showForm" class="heading-span"><span>Package Details</span></h3>
      <h3 class="heading-span" *ngIf="showForm">
        <span>Package Details</span> / Request To Change Package

      </h3>
    </div>
  </header>
  <div class="d-flex align-items-center justify-content-between px-4 py-2 bg-white select-package-border mb-3" *ngIf="!showForm">
    <h3 class="fs-21 font-bold color-black-pearl">Selected Package</h3>
    <button *ngIf="!showForm && (!userRole.includes(roles.SuperAdmin) && !userRole.includes(roles.AccountAdmin))"
      type="button"
      class="btn theme-btn px-4"
      (click)="requestToChangePackage()">
      Request to change Package
    </button>
  </div>
  <div 
  [ngClass]="openedFromMatAccountpreview ? 'table-responsive tab-table package-table p-0 mb-2' : 'table-responsive tab-table matadmin-package-table p-0 mb-2'" 
> 
    <app-package [openedFrom]="openedFromType" [selectedPackage]="assignedPackageId" 
                 [isCurrentTab]="activeTab" [showForm]="showForm"
                 (packageActionTriggered)="closePackageForm($event)"
                 (requestToUpdatePackage)="requestToUpdatePackage($event)"
                 (updateAssignedPackage)="updatePackage($event)"
                 [completedSwapPackage]="completedSwapPackage"
                 (close)="resetCreateTrigger.emit()">
    </app-package>
  </div>
</section>
